import React, { useState } from "react";
import { translate } from "../Services/translation";

export default function CheckoutCampaignSection(props) {
    const { onCampaignCodeChange, onSubmitCampaignCode, errors } = props;
    const [show, setShow] = useState(false);

    return (
        <>
        {/* Hidden for now as Roswis request */}
            {/* <div className="checkout__campaign-container columns">
                <div className="checkout__campaign-header-container">
                    <p
                        className="checkout__campaign-header"
                        onClick={() => setShow(!show)}
                    >
                        Har du en rabattkod?
                    </p>
                    <i
                        className={show ? "fal fa-angle-up" : "fal fa-angle-down"}
                    ></i>
                </div>
                <div
                    className={
                        show
                            ? "checkout__campaign-body-container checkout__campaign-body-container--show"
                            : "checkout__campaign-body-container"
                    }
                >
                    <div className="checkout__campaign-body-wrapper">
                        <div className="checkout__campaign-input-container">
                            <input
                                className="form__input"
                                id="campaign-code"
                                onChange={(event) =>
                                    onCampaignCodeChange(event.target.value)
                                }
                            />
                            <span className="placeholder">
                                {translate("checkout.campaigncode")}
                            </span>
                        </div>
                        <button
                            className="checkout-info__campaign-button button-primary"
                            onClick={() => onSubmitCampaignCode()}
                        >
                            {translate("checkout.usecampaigncode")}
                        </button>
                        {errors && errors["campaignCode"] && (
                            <span
                                className="form__validator--error form__validator--top-narrow"
                                data-error-for="campaign-code"
                            >
                                {errors["campaignCode"][0]}
                            </span>
                        )}
                    </div>
                </div>
            </div> */}
        </>
    );
}
